import { IPayloadAction } from '@src/service/business/common/types';

// -
// -------------------- Types&Consts

export interface IUserSettings {
  locale: string;
}

// -
// -------------------- Selectors

/** Returns UserSettings from store. */
const getUserSettings = (store: any): IUserSettings => store.userSettings;

// -
// -------------------- Actions

const Actions = {
  USER_SETTINGS_UPDATE: 'USER_SETTINGS_UPDATE',
};

/** Update UserSettings to store */
const updateUserSettings = (locale: IUserSettings): IPayloadAction<IUserSettings> => {
  return {
    type: Actions.USER_SETTINGS_UPDATE,
    payload: locale,
  };
};

// -
// -------------------- Side-effects

// -
// -------------------- Reducers

const userSettings = (state: IUserSettings | null = null, action: IPayloadAction<IUserSettings>) => {
  if (action.type === Actions.USER_SETTINGS_UPDATE) {
    return action.payload;
  }

  return state;
};

// --
// -------------------- Business Store

export const UserSettingsBusinessStore = {
  actions: {
    updateUserSettings,
  },

  selectors: {
    getUserSettings,
  },

  effects: {},

  reducers: {
    userSettings,
  },
};

// --
// export business store
export default UserSettingsBusinessStore;
